export default __webpack_public_path__ + "static/media/video-screen.65ffe227.png";